/* eslint-disable */

import 'vue2-datepicker/index.css';

import DatePicker from 'vue2-datepicker'
import Vue from 'vue'
import { bus } from '../../main';
import {
  mapGetters
} from 'vuex';

var $ = window.jQuery = require('jquery');



export default {
  name: 'algo-task-third',
  components: {
    DatePicker
  },
  props: [],
  data () {
    return {
      file2:null,
      uploadFileName2: '',
      uploadingLoader2:false,
      submitted2:false,
      filetype2:'NB',
      resultData2:'',
      errMsgShow2:false,
      errMsg2:'',
      task2:'Diagnostic classification of cervical cancer',
      taskEditAble2:true,
      my_features_data2 :[],
      my_feature_label2:{},
      response_data2:'',
      first_name2:'',
      last_name2:'',
      patient_name2:'', 
      patient_age2:'', 
      patient_gender2:'',
      patient_id2:'',
      patient_date2:'',
      inputAttrList2:[],
      local_Array2: {
        forecast_val: '',
        key:'',
        value: ''
      },
      algorithm_loader2:false,
      attribute2: {
        forecast_key:'',
        forecast_val: '',
        forecast_label: ''
      },
      attributes2: [{
        forecast_key:'x1',
        forecast_val: '1',
        forecast_label: 'Age'
      },{
        forecast_key:'x2',
        forecast_val: '0',
        forecast_label: 'Number of sexual partners'
      },{
        forecast_key:'x3',
        forecast_val: '1',
        forecast_label: 'First sexual intercourse'
      },{
        forecast_key:'x4',
        forecast_val: '1',
        forecast_label: 'Num of pregnancies'
      },{
        forecast_key:'x5',
        forecast_val: '0',
        forecast_label: 'Smokes'
      },{
        forecast_key:'x6',
        forecast_val: '0',
        forecast_label: 'Smokes (years)'
      },{
        forecast_key:'x7',
        forecast_val: '0',
        forecast_label: 'Smokes (packs/year)'
      },{
        forecast_key:'x8',
        forecast_val: '0',
        forecast_label: 'Hormonal Contraceptives'
      },{
        forecast_key:'x9',
        forecast_val: '0',
        forecast_label: 'Hormonal Contraceptives (years)'
      },{
        forecast_key:'x10',
        forecast_val: '0',
        forecast_label: 'IUD'
      },{
        forecast_key:'x11',
        forecast_val: '0',
        forecast_label: 'IUD (years)'
      },{
        forecast_key:'x12',
        forecast_val: '0',
        forecast_label: 'STDs'
      },{
        forecast_key:'x13',
        forecast_val: '0',
        forecast_label: 'STDs (number)'
      },{
        forecast_key:'x14',
        forecast_val: '0',
        forecast_label: 'STDs : condylomatosis'
      },{
        forecast_key:'x15',
        forecast_val: '0',
        forecast_label: 'STDs : cervical condylomatosis'
      },{
        forecast_key:'x16',
        forecast_val: '0',
        forecast_label: 'STDs : vaginal condylomatosis'
      },{
        forecast_key:'x17',
        forecast_val: '0',
        forecast_label: 'STDs : vulvo-perineal condylomatosis'
      },{
        forecast_key:'x18',
        forecast_val: '0',
        forecast_label: 'STDs : syphilis'
      },{
        forecast_key:'x19',
        forecast_val: '0',
        forecast_label: 'STDs : pelvic inflammatory disease'
      },{
        forecast_key:'x20',
        forecast_val: '0',
        forecast_label: 'STDs : genital herpes'
      },{
        forecast_key:'x21',
        forecast_val: '0',
        forecast_label: 'STDs : molluscum contagiosum'
      },{
        forecast_key:'x22',
        forecast_val: '0',
        forecast_label: 'STDs : AIDS'
      },{
        forecast_key:'x23',
        forecast_val: '0',
        forecast_label: 'STDs : HIV'
      },{
        forecast_key:'x24',
        forecast_val: '0',
        forecast_label: 'STDs : Hepatitis B'
      },{
        forecast_key:'x25',
        forecast_val: '0',
        forecast_label: 'STDs : HPV'
      },{
        forecast_key:'x26',
        forecast_val: '0',
        forecast_label: 'STDs : Number of diagnosis'
      },{
        forecast_key:'x27',
        forecast_val: '0',
        forecast_label: 'STDs : Time since first diagnosis'
      },{
        forecast_key:'x28',
        forecast_val: '0',
        forecast_label: 'STDs : Time since last diagnosis'
      },{
        forecast_key:'x29',
        forecast_val: '0',
        forecast_label: 'Dx: Cancer'
      },{
        forecast_key:'x30',
        forecast_val: '0',
        forecast_label: 'Dx: CIN'
      },{
        forecast_key:'x31',
        forecast_val: '0',
        forecast_label: 'Dx: HPV'
      },{
        forecast_key:'x32',
        forecast_val: '0',
        forecast_label: 'Dx'
      },{
        forecast_key:'x33',
        forecast_val: '0',
        forecast_label: 'Hinselmann'
      },{
        forecast_key:'x34',
        forecast_val: '0',
        forecast_label: 'Schiller'
      },{
        forecast_key:'x35',
        forecast_val: '0',
        forecast_label: 'Citology'
      }],
      features2:'35',
      task_number:'',
      userDetails:''
    }
  },
  computed: {
    ...mapGetters([
      'getInputAttrListGetters',
      'selfUserInfoGetters'
    ]),
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.selfUserInfoGetters.data
      return
    },
    // getInputAttrListed2Fun() {
    //   this.$store.dispatch('getInputAttrListFun', { id: 3 }).then((res) => {
    //     this.inputAttrList2 = this.$store.getters.getInputAttrListGetters.data
    //     if (this.inputAttrList2 && this.inputAttrList2.length >= 1) {
    //       this.features2 = this.inputAttrList2.length
    //     } else {
    //       this.features2 = this.attributes2.length
    //     }
    //   }).catch((err) => {

    //   })
    //   return
    // }
  },
  beforeMount(){
    // this.getInputAttrListed2Fun
  },
  mounted () {
    this.getUserDetailsAgainFun
    // this.getInputAttrListed2Fun
  },
  methods: {
    resetFieldFun2(){
      this.uploadFileName2 = '';
      this.patient_name2 = '';
      this.first_name2 = '';
      this.last_name2 = '';
      this.patient_age2 = '';
      this.patient_gender2 = '';
      this.patient_id2 = '';
      this.patient_date2 = '';
      for(var i = 0; i < this.attributes2.length; i++){
        this.attributes2[i].forecast_val = ''
      }
      this.$validator.reset();
    },
    handleFileUpload2(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file2 = event.target.files[0];
        this.files2 = this.$refs.file2.files[0];
        this.filesSize2 = this.$refs.file2.files[0].size;
        this.uploadFileName2 = this.files2.name
      }  else {
        this.uploadFileName2 = '';
      }
    },
    validateFileBeforeSubmit2(e) {
      $(window).scrollTop(0);
      this.my_features_data2 = [],
      this.my_feature_label2 = {}
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.algorithm_loader2 = true
          this.submitted2 = true;
          this.resultData2 = ''
          this.uploadingLoader2 = true
          this.errMsgShow2 = false
          this.errMsg2 = ''
          let formData = new FormData();
          formData.append('name', this.task2);
          formData.append('patient_name2', this.first_name2 + ' ' + this.last_name2);
          formData.append('patient_age2', this.patient_age2);
          formData.append('patient_gender2', this.patient_gender2);
          formData.append('patient_id2', this.patient_id2);
          formData.append('patient_date2', this.patient_date2);
          formData.append('task_number', 3);
          if(this.filetype2 == 'NB'){
            formData.append('algorithm_name', 'Naive Bayes');
          }else if(this.filetype2 == 'RF'){
            formData.append('algorithm_name', 'Random Forest');
          }else if(this.filetype2 == 'DTREE'){
            formData.append('algorithm_name', 'Decision Tree');
          }
          formData.append('data_file', this.file2);
          formData.append('no_of_features', this.features2);
          if(this.inputAttrList2.length >= 1){
            for(var i = 0; i < this.inputAttrList2.length; i++){
                this.my_features_data2.push([this.inputAttrList2[i].forecast_val])
            }
          }else{
            for(var i = 0; i < this.attributes2.length; i++){
              this.my_features_data2.push([this.attributes2[i].forecast_val])
            }
          }
          formData.append('features', this.my_features_data2);
          if(this.inputAttrList2.length >= 1){
          Object.keys(this.inputAttrList2).map((index) => {
            this.my_feature_label2['x' + (parseInt(index) + 1) ] = this.inputAttrList2[index].value
          });}else{
          Object.keys(this.attributes2).map((index) => {
            this.my_feature_label2['x' + (parseInt(index) + 1) ] = this.attributes2[index].forecast_label
          });}
          formData.append('input_attributes', JSON.stringify(this.my_feature_label2));
          if(this.filetype2 == 'NB'){
            this.$store.dispatch('createNbDataFun', formData)
            .then((res) => {
              if (res.status == '200') {
                setTimeout(()=>{
                  this.algorithm_loader2 = false
                  this.resultData2 = res.data
                  this.uploadingLoader2 = false
                },8000)
              }
            })
            .catch((err) => {
              setTimeout(()=>{
              this.errMsgShow2 = true
              this.errMsg2 = err.data
              this.uploadingLoader2 = false
              this.algorithm_loader2 = false
            },8000)
            })
          }else if(this.filetype2 == 'RF'){
            this.$store.dispatch('createRandomForestDataFun', formData)
            .then((res) => {
              if (res.status == '200') {
                setTimeout(()=>{
                  this.algorithm_loader2 = false
                  this.resultData2 = res.data
                  this.uploadingLoader2 = false
                },8000)
              }
            })
            .catch((err) => {
              setTimeout(()=>{
              this.errMsgShow2 = true
              this.errMsg2 = err.data
              this.uploadingLoader2 = false
              this.algorithm_loader2 = false
            },8000)
            })
          }else if(this.filetype2 == 'DTREE'){
            this.$store.dispatch('createDecisionTreeDataFun', formData)
            .then((res) => {
              if (res.status == '200') {
                setTimeout(()=>{
                  this.algorithm_loader2 = false
                  this.resultData2 = res.data
                  this.uploadingLoader2 = false
                },8000)
              }
            })
            .catch((err) => {
              setTimeout(()=>{
              this.errMsgShow2 = true
              this.errMsg2 = err.data
              this.uploadingLoader2 = false
              this.algorithm_loader2 = false
            },8000)
            })
          }
          return
        }
      });
    },
    updateTask2() {
      this.taskEditAble2 = false
    },
    updatedTask2() {
      this.taskEditAble2 = true
    },
    addNewAttributes2 : function () {
      this.attributes2.push(Vue.util.extend({}, this.attribute2))
      this.features = this.attributes2.length
    },
    addApiNewAttributes2: function () {
      this.inputAttrList2.push(Vue.util.extend({}, this.local_Array2))
      this.features2 = this.inputAttrList2.length
    },
    removeApiAttributes2: function (index) {
      Vue.delete(this.inputAttrList2, index);
      this.features2 = this.inputAttrList2.length
    },
    removeAttributes2: function (index) {
      Vue.delete(this.attributes2, index);
      this.features2 = this.attributes2.length
    },
    updateAttributes2(index){
      $('.updateAttributes' + index).addClass('d-none')
      $('.updatedAttributes' + index).removeClass('d-none')
    },
    updatedAttributes2(index){
      $('.updateAttributes' + index).removeClass('d-none')
      $('.updatedAttributes' + index).addClass('d-none')
    }
  },
  watch:{
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.selfUserInfoGetters.data
      return
    },
    // getInputAttrListed2Fun() {
    //   this.$store.dispatch('getInputAttrListFun', { id: 3 }).then((res) => {
    //     this.inputAttrList2 = this.$store.getters.getInputAttrListGetters.data
    //     if (this.inputAttrList2 && this.inputAttrList2.length >= 1) {
    //       this.features2 = this.inputAttrList2.length
    //     } else {
    //       this.features2 = this.attributes2.length
    //     }
    //   }).catch((err) => {

    //   })
    //   return
    // }
  },
}